import React, { useState } from "react";
import i18n from "../lib/i18n";
import ChartSelector from "./ChartSelector";
import TimeBarChart from "./TimeBarChart";
import UIBox from "./UIBox";
import {
  preferredActionTypeColors,
  preferredEnergySavingsColors,
} from "../lib/chartHelpers";

const BuildingGraphs = ({ series, sustainabilityEnabled }) => {
  const [activeTab, setActiveTab] = useState("by_action_type");

  const tabs = [
    {
      key: "by_action_type",
      label: i18n.t("js.components.building_graphs.by_action_type"),
      component: (
        <div id="graph-building-by-action-type">
          <TimeBarChart
            series={series.costs_by_action_type}
            devicePixelRatio={2}
            formatter="currency"
            preferredColors={preferredActionTypeColors()}
            reverseStackingOrder={true}
          />
        </div>
      ),
    },
    ...(sustainabilityEnabled
      ? [
          {
            key: "by_energy_savings_in_kr",
            label: i18n.t(
              "js.components.building_graphs.by_energy_savings_in_kr"
            ),
            component: (
              <div id="graph-building-by-energy-savings-in-kr">
                <TimeBarChart
                  series={series.energy_savings_in_kr}
                  devicePixelRatio={2}
                  formatter="currency"
                  preferredColors={preferredEnergySavingsColors()}
                  reverseStackingOrder={true}
                />
                <div className="info-block info-block--blue">
                  {i18n.t(
                    "js.components.building_graphs.previous_savings_info"
                  )}
                </div>
              </div>
            ),
          },
          {
            key: "by_energy_savings_in_kwh",
            label: i18n.t(
              "js.components.building_graphs.by_energy_savings_in_kwh"
            ),
            component: (
              <div id="graph-building-by-energy-savings-in-kwh">
                <TimeBarChart
                  series={series.energy_savings_in_kwh}
                  devicePixelRatio={2}
                  formatter="energy"
                  preferredColors={preferredEnergySavingsColors()}
                  reverseStackingOrder={true}
                />
                <div className="info-block info-block--blue">
                  {i18n.t(
                    "js.components.building_graphs.previous_savings_info"
                  )}
                </div>
              </div>
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <UIBox>
        <ChartSelector
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />

        <div data-cy={`graph-actions-${activeTab}`} className="mt-40">
          {tabs.find((tab) => tab.key === activeTab).component}
        </div>
      </UIBox>
    </>
  );
};

export default BuildingGraphs;
